import {
  ICajitaLayoutTranslation,
  ICardAsyncFormTranslation,
  ICardFormTranslation,
  ICardSubscriptionAsyncFormTranslation,
  ICashFormTranslation,
  ITransferFormTranslation,
} from "root/shared/MultiLanguage";
import { ITransferSubscriptionTranslation } from "types/cajita_store";
import { IPayoutsCashTranslation } from "types/payouts_cash_form_props";

/**
 * English translation for Cajita Layout
 */
const notAvailableEnglishMessage: string = "Service not available";
const identificationNumber: string = "Identification Number";

export const englishCajitaLayout: ICajitaLayoutTranslation = {
  payButton: ["Pay"],
  payoutButton: ["Request payment"],
  payinButton: ["Generate payment order"],
  selectPaymentMethod: ["Select payment method"],
  selectYourBank: ["Choose your bank"],
  changePaymentMethod: ["Change payment method"],
  subscriptionButton: ["Subscribe"],
  selectorMethods: {
    card: ["Credit or debit card"],
    credit_card: ["Credit card"],
    debit_card: ["Debit card"],
    transfer: ["Transfer"],
    transfer_subscription: ["Transfer Subscriptions"],
    transfer_mxn: ["SPEI (Bank Transfer)"],
    cash: ["Cash"],
    payouts_cash: ["Payments in cash"],
    card_async: ["Debit card"],
    card_dynamic: ["Credit or debit card"],
    card_subscription_dynamic: ["Subscription"],
    card_subscription_async: ["Card Subscription"],
  },
  notAvailable: ["Sorry, Kushki is not available by the moment"],
  notAvailableTransfer: [notAvailableEnglishMessage],
  notAvailableCash: [notAvailableEnglishMessage],
  notAvailableCardAsync: [notAvailableEnglishMessage],
  notAvailableCardSubscriptionAsync: [notAvailableEnglishMessage],
  overlayMessageTitle: ["One moment"],
  overlayMessageSubtitle: ["Processing your payment"],
  cashHelperMessage: [
    "Enter your e-mail and click on “Generate payment order to receive the necessary data to make your transfer.",
  ],
  transferHelperMessage: [
    "Ingresa tu e-mail y haz clic en “Generar orden de pago para recibir los datos necesarios para realizar tu transferencia.",
  ],
  payinTotalAmountMessage: [
    // tslint:disable-next-line:no-invalid-template-strings
    "Your payment order will be generated for ${totalAmount}",
  ],
  footer: {
    learnMore: ["Learn more here"],
    secureMessage: [
      "This payment is being securely processed by Kushki, a Level 1 PCI payment provider. ",
    ],
    changeLanguage: ["Change language"],
    cardDocumentation: ["How to make a payment with a credit card?"],
    pseDocumentation: ["How to make a payment with PSE?"],
  },
  languages: {
    en: ["English"],
    es: ["Spanish"],
    br: ["Portuguese"],
  },
};

/**
 * English translation for cash form
 */

export const englishCashForm: ICashFormTranslation = {
  description: ["Description"],
  identificationInput: [identificationNumber],
  lastNameInput: ["Last name"],
  nameInput: ["Name"],
  email: ["E-mail"],
};

/**
 * English translation for card form
 */

export const englishCardForm: ICardFormTranslation = {
  cardHolder: ["First and surname"],
  cardNumber: ["Card Number"],
  expDate: ["MM/YY"],
  cardCVC: ["CVV"],
  email: ["E-mail"],
  deferredOptionsComponent: {
    deferredTypeSelectLabel: ["Deferred type"],
    monthsSelectLabel: ["Months"],
    monthsOfGraceSelectLabel: ["Months of Grace"],
    toggleTitle: ["Defer my payment"],
  },
  invalidOtpMessage: ["Invalid OTP"],
  otpKushkiTitle: [
    "Check the notification that your bank sent you by SMS or email.",
  ],
  otpDinersTitle: [
    "The temporary security key has been sent to your registered email or cell phone.",
  ],
  messageDiners: ["Enter your temporary password below:"],
  messageKushki: [
    "We have made a small charge to your card as HELP_KUSHKI VERIFICATION, which will be reversed immediately. The charge made has three (3) figures, which must be entered below:",
  ],
  howItWorks: ["How it works?"],
  otpTitle: ["Verification"],
  tryWithAnotherCard: ["Try another card"],
  otpButtonText: ["Confirm code"],
  helpText: [
    "The security code that you must enter in the boxes is a random value that you will receive via SMS or email." +
      " This value will be debited on your card and will be reversed immediately without generating an additional expense to your purchase.",
  ],
  exampleText: {
    firstPhrase: ["If the charge notified by email or SMS was of"],
    secondPhrase: [", you must enter the boxes:"],
    forExample: ["For example:"],
  },
  transactionResume: ["Transaction resume"],
  valueToPay: ["Amount to be paid:"],
  numberOffees: ["Number of fees:"],
  amountPerFee: ["Amount per fee"],
  continue: ["Continue"],
  back: ["Back"],
  commission: {
    link: ["Show commission details"],
    title: ["Commission details"],
    text: ["Below is a detail of how the values of your purchase are divided:"],
  },
  exceededRetries: {
    title: ["There have been too many failed attempts"],
    description: [
      "The verification could not be completed because you have failed too many attempts. Please try again",
    ],
    note: [
      "*Remember that the amount charged or debited from your card will be reversed immediately.",
    ],
    button: ["Try another card"],
  },
};

/**
 * English translation for transfer subscription form
 */

export const englishTransferSubscriptionForm: ITransferSubscriptionTranslation = {
  name: ["Name"],
  lastName: ["Last name"],
  documentType: ["Document type"],
  documentNumber: [identificationNumber],
  accountTypeLabel: ["Account type"],
  accountType: {
    "01": ["Savings"],
    "02": ["Current"],
  },
  bankId: ["Bank"],
  accountNumber: ["Account Number"],
  email: ["Email"],
  waitMoment: ["Just a moment!"],
  confrontaDescription: [
    "For security reasons we need to validate some additional data but do not worry about this,",
  ],
  confrontaDescriptionStrong: ["we will do it only once."],
  howItWorks: ["How it works?"],
  dataVerificationLabel: ["Data verification"],
  confirmButtonText: ["Confirm"],
  cancelButtonText: ["Cancel"],
  adviceDocumentNumber: [
    "Complete the following information, related to the identity document:",
  ],
  continueButtonText: ["Continue"],
  selectYourDepartment: ["Select your state..."],
  selectYourCity: ["Select your city..."],
  cityLabel: ["City"],
  departmentLabel: ["Department"],
  expeditionDateLabel: ["Expedition date"],
  howItWorksMessage: [
    "After validating your identity data, we will show you several questions about your personal and / or banking data that you must answer correctly to carry out the transaction.",
  ],
};

/**
 * English translation for card async form
 */
export const englishCardAsyncForm: ICardAsyncFormTranslation = {
  emailInput: ["Email"],
};

/**
 * English translation for card async form
 */
export const englishCardSubscriptionAsyncForm: ICardSubscriptionAsyncFormTranslation = {
  emailInput: ["Email"],
  cardNumber: ["Card Number"],
};

/**
 * English translation for transfer form
 */
export const englishTransferForm: ITransferFormTranslation = {
  documentEmailInput: ["Email"],
  documentNumberInput: [identificationNumber],
  paymentDescriptionInput: ["Description"],
  bankListSelectLabel: ["Debit from your checking or savings account"],
  userTypeRadioGroupLabel: ["Person type"],
  userTypeRadioGroup: {
    "0": ["Natural"],
    "1": ["Legal"],
  },
};

/**
 * English PayoutsCashForm for transfer form
 */

export const englishPayoutsCashForm: IPayoutsCashTranslation = {
  nameInput: ["Name"],
  lastNameInput: ["Last Name"],
  identificationInput: [identificationNumber],
  description: ["Description"],
  email: ["E-mail"],
};



// WEBPACK FOOTER //
// ./src/shared/Languages/English.ts